var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2524 1.1924L12.2521 1.19204C12.0644 1.00502 11.8105 0.9 11.5457 0.9C11.2809 0.9 11.027 1.00502 10.8393 1.19204L10.8392 1.19217L1.77735 10.257L1.7571 10.2772L1.75065 10.3051L0.923277 13.8822L0.923269 13.8822L0.923005 13.8834C0.891293 14.0287 0.89238 14.1792 0.926187 14.324C0.959994 14.4688 1.02567 14.6043 1.11843 14.7204C1.21119 14.8366 1.32869 14.9305 1.46236 14.9954C1.5946 15.0596 1.73936 15.0936 1.88627 15.0952C1.95367 15.1017 2.02155 15.1016 2.08893 15.0948L2.08901 15.0955L2.10124 15.0927L5.71118 14.2639L5.73921 14.2575L5.75954 14.2371L14.8083 5.18106L14.8085 5.18085C14.9952 4.99289 15.1 4.73856 15.1 4.47349C15.1 4.20842 14.9952 3.95409 14.8086 3.76613L12.2524 1.1924ZM11.892 6.61957L5.20374 13.2895L2.00266 13.9622L2.73154 10.8188L9.42053 4.14378L11.892 6.61957ZM12.6161 5.84482L10.1457 3.37004L11.5188 2.00243L13.9489 4.47808L12.6161 5.84482Z",
    fill: "#2E314E",
    stroke: "#2E314E",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.80f83e2d9568210e9c17fdf09b6efefb.svg";
export { ForwardRef as ReactComponent };